module.exports = __webpack_public_path__ + "img/sweden-genitourinary-diseases-female.d11d0fcd.png";